import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './alert.css';
const MySwal = withReactContent(Swal);


const showAlert = (title,text,icon,buttonText,clickClose,cancelButton,activityCallback,denyButton,secondButtonText,secondButtonCallback) => {
    MySwal.fire({
      title: title,
      text: text,
      icon: icon,
      confirmButtonText: buttonText,
      allowOutsideClick: clickClose,
      showCancelButton: cancelButton,
      cancelButtonColor: "#DD6B55",
      confirmButtonColor: "#1b6098",
      showDenyButton: denyButton,
      denyButtonText: secondButtonText,
      denyButtonColor: "#4adac1",
      customClass: {
        confirmButton: 'yes_swal_button_space',
        denyButton: 'swal_button_space' 
      }
    }).then((result) => {
      if (result.isConfirmed) {
          if (activityCallback && typeof activityCallback === 'function') {
              activityCallback(result.value ? result.value : 'No value');
          }
      } else if (result.isDenied) {
          if (secondButtonCallback && typeof secondButtonCallback === 'function') {
              secondButtonCallback(true);
          }
      }
  });
};
export default showAlert;



//  showAlert('testing', 'SweetAlert in React', 'success', 'Ok', false, handleActivity);
// const handleActivity = (value) => {
    //console.log('value' + value);
       // }